"use strict";

var currentLength,
  currentSizeVal = localStorage.getItem("fontsizeVal"),
  currentSize = parseFloat(currentSizeVal),
  transalationcurrentSizeVal = localStorage.getItem("translationsizeVal"),
  translationcurrentSize = parseFloat(transalationcurrentSizeVal);
function updateTextInput(e) {
  var t;
  currentLength = 100 * currentSize / 5 - 9, (.5 < currentSize || currentSize < 1.5) && (t = parseFloat(e), currentSize = 5 * (t + 9) / 100, t = parseFloat(e) + 23, $(".translationText").css("zoom", currentSize), localStorage.setItem("translationsizeVal", t), currentSize <= .7 ? $(".arabic span img").css("margin-left", "-5px") : $(".arabic span img").css("margin-left", "0px"), $(".arabic span img").css("zoom", currentSize), localStorage.setItem("fontsizeVal", currentSize), currentLength = 100 * currentSize / 5 - 9, document.getElementById("progress").value = currentLength, localStorage.setItem("fontsizeProgress", currentLength));
}
null == currentSizeVal && (localStorage.setItem("fontsizeVal", 1), localStorage.setItem("translationsizeVal", 34), translationcurrentSize = 34, currentLength = 100 * (currentSize = 1) / 5 - 9, localStorage.setItem("fontsizeProgress", currentLength)), $(document).on("click", "#decrement-Btn", function () {
  var e = localStorage.getItem("translationsizeVal"),
    e = parseFloat(e);
  .5 < currentSize && (e -= 1, (currentSize -= .05) <= .7 ? $(".arabic span img").css("margin-left", "-5px") : $(".arabic span img").css("margin-left", "0px"), $(".arabic span img").css("zoom", currentSize), localStorage.setItem("fontsizeVal", currentSize), $(".translationText").css("zoom", currentSize), localStorage.setItem("translationsizeVal", e), currentLength = 100 * currentSize / 5 - 9, document.getElementById("progress").value = currentLength, localStorage.setItem("fontsizeProgress", currentLength));
}), $(document).on("click", "#increment-Btn", function () {
  var e = localStorage.getItem("translationsizeVal"),
    e = parseFloat(e);
  currentSize < 1.5 && (e += 1, (currentSize += .05) <= .7 ? $(".arabic span img").css("margin-left", "-5px") : $(".arabic span img").css("margin-left", "0px"), $(".arabic span img").css("zoom", currentSize), localStorage.setItem("fontsizeVal", currentSize), $(".translationText").css("zoom", currentSize), localStorage.setItem("translationsizeVal", e), currentLength = 100 * currentSize / 5 - 9, document.getElementById("progress").value = currentLength, localStorage.setItem("fontsizeProgress", currentLength));
});
function addNewBookmark(s) {
  parseInt(dataId);
  var i,
    t = parseInt(lastId.split("-")[0]),
    o = parseInt(lastId.split("-")[1]);
  scrollSelections.getAyatRelations().then(function (e) {
    for (var a = 0; a < e.length; a++) if (e[a][0] === parseInt(t) && e[a][4] === parseInt(o)) {
      i = a + 1, e[a];
      break;
    }
    getSurahName(t).then(function (e) {
      var a = {
          accessDate: {
            ".sv": "timestamp"
          },
          creationDate: {
            ".sv": "timestamp"
          },
          id: parseInt(i),
          openedCount: 0,
          title: s,
          type: 0
        },
        t = [],
        o = [],
        n = firebase.database().ref(firebaseNode + "/" + userId + "/Data/");
      n.get().then(function (e) {
        e.forEach(function (e) {
          o.push(e), t.push(e.key);
        }), o.push(a), n.set(JSON.parse(JSON.stringify(o))).then(function (e) {
          firebase.database().ref(firebaseNode + "/" + userId + "/").update({
            UpdateTime: {
              ".sv": "timestamp"
            }
          }).then(function (e) {
            getUserBookmarksOnLoad(userId);
          })["catch"](function (e) {
            console.log("Bookmark update failed1: " + e.message);
          });
        })["catch"](function (e) {
          console.log("Bookmark update failed2: " + e.message);
        });
      })["catch"](function (e) {
        console.log("Bookmark update failed3: " + e.message);
      });
    });
  });
}
$(document).on("click", "#btmEmptyBookmark-Btn", function () {
  var t,
    o,
    e = parseInt(dataId);
  isNaN(e) || 0 !== e && (t = parseInt(lastId.split("-")[0]), o = parseInt(lastId.split("-")[1]), 0 != lastId) && getSurahName(t).then(function (e) {
    var a = t + " " + e + ", Aya " + o;
    $(function () {
      $(window).resize(function () {
        $("#addBookmarkDialog").dialog("option", "position", {
          my: "center",
          at: "center",
          of: window
        });
      }), $("#addBookmark_req").css("display", "none"), $("#addBookmarkDialog").dialog({
        title: "Add Bookmark",
        width: "auto",
        maxWidth: 600,
        modal: !0,
        autoOpen: !1,
        open: function open(e, a) {
          $(e.target).dialog("widget").css({
            position: "fixed"
          }).position({
            my: "center",
            at: "center",
            of: window
          });
        },
        resizable: !1,
        draggable: !1,
        closeOnEscape: !0,
        buttons: [{
          id: "confirmBtnAddBookmark",
          text: "Confirm",
          click: function click() {
            var e = document.getElementById("newBookId").value;
            0 < e.length ? ($("#btmEmptyBookmark-Btn").css("display", "none"), $("#btmBookmark-Btn").css("display", "inline"), addNewBookmark(e), $(this).dialog("close")) : $("#addBookmark_req").css("display", "inline");
          }
        }, {
          id: "Cancel",
          text: "Cancel",
          click: function click() {
            $(this).dialog("close");
          }
        }]
      }), $(".dialog-body #newBookId").val(a), $(".ui-dialog-titlebar-close").hide(), $("#addBookmarkDialog").dialog("open");
    });
  });
});
function getUserBookmarksOnLoad(e) {
  var t = [];
  return new Promise(function (a, o) {
    firebase.database().ref(firebaseNode + "/" + e + "/Data/").get().then(function (e) {
      e.exists() && (userBookmarks = [], userReadingBookmark = "", bookmarkString = "", e.forEach(function (e) {
        var a = JSON.parse(JSON.stringify(e)).id;
        7e3 === a ? (e = JSON.parse(JSON.stringify(e)).title.split("|")[1], userReadingBookmark = e, bookmarkString = e) : 0 < a - 1 && t.push(a);
      }), userBookmarks = t, bookmarkString = bookmarkString + "|" + t, a(bookmarkString));
    })["catch"](function (e) {
      console.error(e), o(e.message);
    });
  }).then(function (e) {});
}
function updateBookmarkAfterDelete(e, a, o) {
  firebase.database().ref(firebaseNode + "/" + userId + "/Data/").set(JSON.parse(JSON.stringify(e))).then(function (e) {
    firebase.database().ref(firebaseNode + "/" + userId + "/").update({
      UpdateTime: {
        ".sv": "timestamp"
      }
    }).then(function (e) {
      o ? ($("#btmEmptyBookmark-Btn").css("display", "inline"), $("#btmBookmark-Btn").css("display", "none")) : (a ? ($("#btmEmptyReadingBookmark-Btn").css("display", "none"), $("#btmReadingBookmark-Btn")) : ($("#btmEmptyBookmark-Btn").css("display", "none"), $("#btmBookmark-Btn"))).css("display", "inline"), getUserBookmarksOnLoad(userId);
    })["catch"](function (e) {
      console.log("Bookmark update failed1: " + e.message);
    });
  })["catch"](function (e) {
    console.log("Bookmark update failed2: " + e.message);
  });
}
function addDefaultBookmark(r) {
  return new Promise(function (a, o) {
    var t = [],
      s = firebase.database().ref(firebaseNode + "/" + r + "/Data/");
    t.push({
      accessDate: {
        ".sv": "timestamp"
      },
      creationDate: {
        ".sv": "timestamp"
      },
      id: 7e3,
      openedCount: 0,
      title: "ReadingBookmark|1|",
      type: 1
    }), s.get().then(function (e) {
      e.exists() ? (getBookmarkByUserId(r, "def"), a("DefaultBookmark not added1!")) : s.set(JSON.parse(JSON.stringify(t))).then(function (e) {
        firebase.database().ref(firebaseNode + "/" + r + "/").update({
          UpdateTime: {
            ".sv": "timestamp"
          }
        }).then(function (e) {
          getBookmarkByUserId(r, "def"), a("DefaultBookmark added2!");
        })["catch"](function (e) {
          console.log("addDefaultBookmark failed1: " + e.message), o("DefaultBookmark failed1!");
        });
      })["catch"](function (e) {
        console.log("addDefaultBookmark failed2: " + e.message), o("DefaultBookmark failed2!");
      });
    })["catch"](function (e) {
      console.error(e), o(e.message);
    });
  });
}
function deleteBookmarkID2(e, a, t, o, n) {
  var r = [],
    l = [];
  new Promise(function (o, t) {
    e.database().ref(firebaseNode + "/" + a + "/Data/").get().then(function (e) {
      e.forEach(function (e) {
        l.push(e), r.push(e.key), o(l);
      });
    })["catch"](function (e) {
      t(e.message), console.error(e.message);
    });
  }).then(function (e) {
    e = e.filter(function (o) {
      return !t.find(function (e) {
        return e == JSON.parse(JSON.stringify(o)).id;
      });
    });
    console.log("remove999 " + JSON.stringify(e)), updateBookmarkAfterDelete(e, o, n);
  });
}
function getDelAya(e) {
  var a = (e = e.toString()).split("-")[0],
    n = e.split("-")[1];
  return console.log("ayatIdpromise " + e), new Promise(function (t, e) {
    scrollSelections.getAyatRelations().then(function (e) {
      for (var o = 0; o < e.length; o++) if (e[o][0] === parseInt(a) && e[o][4] === parseInt(n)) {
        console.log("urlSHARE2 ayat: " + (o + 1) + " relation: " + e[o]), dalAyatNo = o + 1, shareAyatRelation = e[o], console.log("remove999 " + JSON.stringify(dalAyatNo)), t(dalAyatNo);
        break;
      }
    });
  });
}
$(document).on("click", "#btmBookmark-Btn", function () {
  var t,
    a,
    e = parseInt(dataId);
  isNaN(e) || 0 !== e && (console.log("TEST dataId: " + e + " lastId: " + lastId), t = parseInt(lastId.split("-")[0]), a = parseInt(lastId.split("-")[1]), getSurahName(t).then(function (e) {
    var o = t + " " + e + ", Aya " + a;
    $(function () {
      $("#removeBookmarkDialog").dialog({
        title: "Remove Bookmark",
        modal: !0,
        autoOpen: !1,
        resizable: !1,
        draggable: !1,
        closeOnEscape: !0,
        buttons: [{
          id: "confirmBtnRemoveBookmark",
          text: "Confirm",
          click: function click() {
            console.log("confirmBtnRemoveBookmark clicked."), $(this).dialog("close"), getDelAya(dataIdID).then(function (e) {
              var o = parseInt(e),
                t = [];
              t.push(o), console.log("confirmBtnRemoveBookmark clicked." + e), deleteBookmarkID2(firebase, userId, t, !1, !0);
            });
          }
        }, {
          id: "Cancel",
          text: "Cancel",
          click: function click() {
            $(this).dialog("close");
          }
        }]
      }), $(".dialog-body #removeBookmarkName").text("'" + o + "' ?"), $(".ui-dialog-titlebar-close").hide(), $("#removeBookmarkDialog").dialog("open");
    });
  }));
});
function updateReadingBookmark(a) {
  firebase.database().ref(firebaseNode + "/" + userId + "/Data/").orderByChild("id").equalTo(7e3).once("value").then(function (e) {
    e.forEach(function (e) {
      e.ref.update({
        title: "ReadingBookmark|" + a + "|",
        type: 1,
        creationDate: {
          ".sv": "timestamp"
        }
      }).then(function (e) {
        firebase.database().ref(firebaseNode + "/" + userId + "/").update({
          UpdateTime: {
            ".sv": "timestamp"
          }
        }).then(function (e) {
          getUserBookmarksOnLoad(userId);
        })["catch"](function (e) {
          console.log("Bookmark update failed1: " + e.message);
        });
      })["catch"](function (e) {
        console.log("Bookmark update failed1: " + e.message);
      }), console.log("Bookmark updated: " + e.key);
    });
  })["catch"](function (e) {
    console.log("Bookmark update failed: " + e.message);
  });
}
$(document).on("click", "#btmEmptyReadingBookmark-Btn", function () {
  var t,
    o,
    n,
    e = parseInt(dataId);
  isNaN(e) || 0 !== e && (t = parseInt(lastId.split("-")[0]), o = parseInt(lastId.split("-")[1]), scrollSelections.getAyatRelations().then(function (e) {
    for (var a = 0; a < e.length; a++) if (e[a][0] === parseInt(t) && e[a][4] === parseInt(o)) {
      n = a + 1, e[a];
      break;
    }
    $("#btmEmptyReadingBookmark-Btn").css("display", "none"), $("#btmReadingBookmark-Btn").css("display", "inline"), updateReadingBookmark(n);
  }));
});
function getSurahName(o) {
  return new Promise(function (n, a) {
    var s;
    $.ajax({
      url: "/JSONFiles/surahNames.json",
      dataType: "json",
      cache: !0,
      success: function success(e) {
        s = e.SurahEnglishNames[o - 1], n(s);
      },
      error: function error(e, n, s) {
        console.log("read 2 " + e + " " + n.Mess + " " + s), a(s);
      },
      complete: function complete() {}
    });
  });
}
function isInternetAvailable() {
  return !!navigator.onLine;
}
function offlineMessage() {
  isInternetAvailable() ? console.log("online") : (showToast("Internet connection failed"), console.log("offline"));
}
$(document).on("click", "#btnPlayAudio-Btn, #btnPauseAudio-Btn", offlineMessage);